import script from "./NumbersComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./NumbersComponent.vue?vue&type=script&lang=ts&setup=true"

import "./NumbersComponent.vue?vue&type=style&index=0&id=42562baa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42562baa"]])

export default __exports__